
import Vue from 'vue';
import _, {startCase} from 'lodash'
import store from '@/store';
import { Component, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action } from 'vuex-class';
import { Category } from '@/types/categories';
import CategoryListTile from '../../components/Category/CategoryListTile.vue';
import { VueNestable, VueNestableHandle } from 'vue-nestable';
import { MenuItem } from '@/types/menus';

@Component({
  components: { CategoryListTile, VueNestable },
})
export default class CategoryList extends Vue {
  @Action('categories/getCategories') getCategories!: Function;
  @Action('categories/saveCategoryOrder') saveCategoryOrder!: Function;

  categories: Category[] = [];

  created() {
    this.categories = this.$store.getters['categories/categories'];
  }

  get pageName() {
    const name = this.$route.name || undefined;
    return _.startCase(name);
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('categories/getCategories');
    next();
  }

  @Watch('categories')
  onMenuItemsChanged(value?: any[], oldValue?: any[]) {
    if (!_.isEqual(value, oldValue)) {
      const update = _.map(value, function(item: MenuItem) {
        return {
          id: item.id,
          children: _.map(item.children, function(child: MenuItem) {
            return { id: child.id };
          }),
        };
      });
      this.saveCategoryOrder(update);
    }
  }

  newCategory() {
    this.$router.push('/categories/editor');
  }
}
